import { IconRender } from "@/components/shared/Icon-render";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { GenericType } from "@/types";
import { useState } from "react";
export const PasswordInput = ({
  field,
  icon,
  placeholder,
  className,
  iconClassName,
}: GenericType) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  return (
    <div className="relative">
      {icon ? (
        <IconRender
          className={cn(
            "absolute left-2 top-0 bottom-0 my-auto z-[1]",
            iconClassName
          )}
          name={icon}
          strokeWidth={1}
          size={17}
        />
      ) : null}
      <Input
        className={cn({ "pl-8 pr-8": icon }, className)}
        placeholder={placeholder}
        type={passwordVisible ? "text" : "password"}
        {...field}
      />
      <Button
        variant="ghost"
        onClick={() => setPasswordVisible(!passwordVisible)}
        className="absolute  right-0 top-0 bottom-0 my-auto"
        size={"icon"}
        type="button"
      >
        <IconRender
          name={passwordVisible ? "Eye" : "EyeOff"}
          strokeWidth={1}
          size={17}
        />
      </Button>
    </div>
  );
};
